// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__i5x2M","list":"PatternAutocomplete_list__C7fRw"};